declare const jQuery: any;
const $ = jQuery;

const setCookie: Function = window["iw"].cookies.setCookie;
const getCookie: Function = window["iw"].cookies.getCookie;

const cookieName: string = "hsposttype";
const defaultPostType: string = "product";
const cookieLifetime: number = 365; // days

const $body = $(document.body);

export type PostTypeValue = "product"|"supplier";

export function initPostTypeCookie(): void
{
    setupBodyClassSwitch();
    try
    {
        setCookieFromUrlHash();
    }
    catch (e)
    {
        console.error(`Failed to set cookie from url hash:`, e);
    }
    debugPrintCookieValue();
}

function setupBodyClassSwitch(): void
{
    $(document).on("posttypechanged", (event, data) => {
        const postType: PostTypeValue = data.value;
        $body.removeClass("hsmode-product hsmode-supplier").addClass(`hsmode-${postType}`);
    });
}

export function setCookieFromUrlHash(): void
{
    if ($("body.hs-check-posttype").length === 0)
    {
        return;
    }
    const hash: string = window.location.hash;
    if (!hash)
    {
        return;
    }
    const postTypeNameSingular: string = hash.toLowerCase().replace(/(\#)|(s$)/gi, "");
    setPostTypeCookie(postTypeNameSingular);
}

export function setPostTypeCookie(postTypeNameSingular: string): void
{
    if (postTypeNameSingular === getSelectedPostType())
    {
        // No change
        return;
    }
    if (postTypeNameSingular === "product" || postTypeNameSingular === "supplier")
    {
        setCookie(cookieName, postTypeNameSingular, cookieLifetime);
        $(document).trigger("posttypechanged", {
            value: postTypeNameSingular
        });
        if (window["iw"].DEBUG)
        {
            console.log("Changed post type cookie value:", getSelectedPostType());
        }
    }
    else
    {
        console.error(`Invalid postTypeNameSingular:`, postTypeNameSingular);
    }
}

export function togglePostTypeCookie(): void
{
    const postTypeNameSingular: PostTypeValue = (getSelectedPostType() === "product") ? "supplier" : "product";
    setPostTypeCookie(postTypeNameSingular);
}

export function getSelectedPostType(): PostTypeValue
{
    return getCookie(cookieName) || defaultPostType;
}

function debugPrintCookieValue(): void
{
    if (window["iw"].DEBUG)
    {
        console.log("Post type cookie initial value:", getSelectedPostType());
    }
}
